<template>
  <div>
    <h5 class="mb-3">{{ $t("lang.label_certificate_history") }}</h5>
    <b-table responsive="sm" :items="audits" :fields="fields"></b-table>
  </div>
</template>
<script>
import API from "@/api";
import moment from "moment";
import * as utils from "@/utils";
export default {
  name: "ViewCertificateAudit",
  props: {
    certificateId: {
      required: true
    }
  },
  data() {
    return {
      fields: [
        {
          key: "eventDescription",
          label: this.$t("lang.label_certificate_audit_event_description"),
          formatter(value) {
            return value
              .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
                return index === 0 ? word.toUpperCase() : word.toLowerCase();
              })
              .replace(/_/g, " ");
          }
        },
        {
          key: "occurredDate",
          label: this.$t("lang.label_certificate_audit_event_date"),
          formatter: value => {
            return moment(String(value)).format(utils.constants.DATE_TIME_PATTERN);
          }
        }
      ],
      audits: []
    };
  },
  methods: {
    getCertificateAudits() {
      this.$store.dispatch("startLoading");
      API.getCertificateAudits(this.$props.certificateId)
        .then(response => {
          this.$store.dispatch("stopLoading");
          this.audits = response.data;
        })
        .catch(() => {
          this.$store.dispatch("stopLoading");
          this.$store.dispatch("alert/showFailureAlert", "Loading certificate audits failed");
        });
    }
  },
  mounted() {
    this.getCertificateAudits();
  }
};
</script>
